export const FETCH_BANKS_EXCHRATES_LIST = 'FETCH_BANKS_EXCHRATES_LIST';
